// extracted by mini-css-extract-plugin
module.exports = {"component":"LinksSection_component__1JQ7n","componentCover":"LinksSection_componentCover__2sGB_"};